module.exports = __webpack_public_path__ + "media/5.d4b670f9.mp3";